// extracted by mini-css-extract-plugin
export var footer = "_oe-5";
export var fulfillmentInput = "_oe-0";
export var shipDateInput = "_oe-1";
export var shipmentModal = "_oe-2";
export var shipmentModalContent = "_oe-3";
export var tableContainer = "_oe-4";